module.exports = __webpack_public_path__ + "static/media/mute.ebb5807f.svg";